import React, { Component } from 'react';
import config from '../../config';
import Helmet from 'react-helmet';

export default class Copyright extends Component {
  render() {
    return (
      <div className="container">
        <Helmet
          title="Twine Engagement Terms and Conditions"
          link={[
            { rel: 'canonical', href: config.baseUrl + '/engagement-terms' },
          ]}
        />

        <h1 className="lato-bold text-uppercase text-center aside-text mt mb">
          Twine Engagement Terms and Conditions
        </h1>

        <div className="panel p++">
          <p className="lato-regular">
            <strong>PLEASE READ THESE TERMS CAREFULLY</strong>
          </p>
          <p className="lato-regular">
            Where selected by a Buyer, these terms and conditions apply to
            engagements with Sellers facilitated by the Twine Platform.
          </p>

          <ol>
            <li>
              <h3 className="lato-bold mt mb pl">Interpretation</h3>
              <p className="lato-regular">1.1 &nbsp;&nbsp;Definitions:</p>
              <p className="lato-regular">
                <strong>Business Day:</strong> a day other than a Saturday,
                Sunday or public holiday in England, when banks in London are
                open for business.
              </p>
              <p className="lato-regular">
                <strong>Buyer:</strong> The buyer of the Services, being an
                individual, partnership or company, as set out in the Twine
                Order Form.
              </p>
              <p className="lato-regular">
                <strong>Buyer Materials:</strong> has the meaning set out in
                clause 3.3(j).
              </p>
              <p className="lato-regular">
                <strong>Charges:</strong> the charges payable by the Buyer for
                the supply of the Services in accordance with clause 6 (Charges
                and payment).
              </p>
              <p className="lato-regular">
                <strong>Commencement Date:</strong> has the meaning given in
                clause 2.2.
              </p>
              <p className="lato-regular">
                <strong>Conditions:</strong> these terms and conditions as
                amended from time to time in accordance with clause 11.5.
              </p>
              <p className="lato-regular">
                <strong>Contract:</strong> the contract between the Buyer and
                the Seller for the supply of Services in accordance with these
                Conditions.
              </p>
              <p className="lato-regular">
                <strong>Output:</strong> all documents, products and materials
                developed by the Seller or (where relevant) its employees as
                part of or in relation to the Services in any form or media,
                including drawings, maps, plans, diagrams, designs, pictures,
                computer programs, data, specifications, recordings and reports
                (including drafts).
              </p>
              <p className="lato-regular">
                <strong>Intellectual Property Rights:</strong> patents, utility
                models, rights to inventions, copyright and neighbouring and
                related rights, moral rights, trade marks and service marks,
                business names and domain names, rights in get-up and trade
                dress, goodwill and the right to sue for passing off or unfair
                competition, rights in designs, rights in computer software,
                database rights, rights to use, and protect the confidentiality
                of, confidential information (including know-how and trade
                secrets), and all other intellectual property rights, in each
                case whether registered or unregistered and including all
                applications and rights to apply for and be granted, renewals or
                extensions of, and rights to claim priority from, such rights
                and all similar or equivalent rights or forms of protection
                which subsist or will subsist now or in the future in any part
                of the world.
              </p>
              <p className="lato-regular">
                <strong>Order:</strong> the Buyer's order for the supply of
                Services, as set out in the Twine Order Form.
              </p>
              <p className="lato-regular">
                <strong>Seller:</strong> The seller of the Services, being an
                individual, partnership or company, as set out in the Twine
                Order Form.
              </p>
              <p className="lato-regular">
                <strong>Services:</strong> the services, including any Output,
                to be provided by the Seller under the Contract, as set out in
                the Twine Order Form.
              </p>
              <p className="lato-regular">
                <strong>Specification:</strong> the description or specification
                for the Services set out in the Twine Order Form or as agreed in
                writing by the Buyer and the Seller.
              </p>
              <p className="lato-regular">
                <strong>Twine:</strong> Clowdy Limited, trading as "Twine", a
                company registered in England and Wales with company
                registration number is 08195808 and whose registered office is
                at 3rd Floor, 86-90 Paul Street, London EC2A 4NE.
              </p>
              <p className="lato-regular">
                <strong>Twine Order Form:</strong> the form completed by the
                Buyer on the Twine Platform for the order of Services from the
                Seller.
              </p>
              <p className="lato-regular">
                <strong>Twine Platform:</strong> the platform operated by Twine
                through which the Buyer and Seller have engaged at www.twine.net
                or www.twine.net.
              </p>

              <p className="lato-regular">1.2 &nbsp;&nbsp;Interpretation:</p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;A reference to a statute or statutory provision
                    is a reference to it as amended or re-enacted. A reference
                    to a statute or statutory provision includes all subordinate
                    legislation made under that statute or statutory provision.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Any words following the terms{' '}
                    <b>including, include, in particular, for example</b> or any
                    similar expression shall be construed as illustrative and
                    shall not limit the sense of the words, description,
                    definition, phrase or term preceding those terms.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;A reference to <b>writing</b> or <b>written</b>{' '}
                    includes email.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Basis of contract</h3>
              <p className="lato-regular">
                2.1 &nbsp;&nbsp;The Order constitutes an offer by the Buyer to
                purchase Services in accordance with these Conditions.
              </p>
              <p className="lato-regular">
                2.2 &nbsp;&nbsp;The Order shall be deemed to be accepted by any
                act by the Seller consistent with fulfilling the Order at which
                point and on which date the Contract shall come into existence (
                <b>"Commencement Date"</b>).
              </p>
              <p className="lato-regular">
                2.3 &nbsp;&nbsp;These Conditions apply to the Contract to the
                exclusion of any other terms that the Seller seeks to impose or
                incorporate, or which are implied by law, trade custom, practice
                or course of dealing.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Supply of Services</h3>
              <p className="lato-regular">
                3.1 &nbsp;&nbsp;The Seller shall from the date set in the Order
                and for the duration of the Contract provide the Services to the
                Buyer in accordance with the terms of the Contract.
              </p>
              <p className="lato-regular">
                3.2 &nbsp;&nbsp;The Seller shall meet any performance dates for
                the Services specified in the Order or that the Buyer notifies
                to the Seller.
              </p>
              <p className="lato-regular">
                3.3 &nbsp;&nbsp;In providing the Services, the Seller shall:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;co-operate with the Buyer in all matters
                    relating to the Services, and comply with all instructions
                    of the Buyer;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;perform the Services with the best care, skill
                    and diligence in accordance with best practice in the
                    Seller's industry, profession or trade;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;(where relevant) use personnel who are suitably
                    skilled and experienced to perform tasks assigned to them,
                    and in sufficient number to ensure that the Seller's
                    obligations are fulfilled in accordance with the Contract;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;ensure that the Services will conform with all
                    descriptions, standards and specifications set out in the
                    Specification, and that the Output shall be fit for any
                    purpose that the Buyer expressly or impliedly makes known to
                    the Seller;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;provide all equipment, tools and vehicles and
                    such other items as are required to provide the Services;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;use the best quality goods, materials, standards
                    and techniques, and ensure that the Output, and all goods
                    and materials supplied and used in the Services or
                    transferred to the Buyer, will be free from defects in
                    workmanship, installation and design;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;obtain and at all times maintain all licences
                    and consents which may be required for the provision of the
                    Services;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;comply with all applicable laws, regulations,
                    regulatory policies, guidelines or industry codes which may
                    apply from time to time to the provision of the Services,
                    and with any policies of the Buyer that the Buyer makes
                    known to the Seller;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;(where relevant) observe all health and safety
                    rules and regulations and any other security requirements
                    that apply at any of the Buyer's premises;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;hold all materials, equipment and tools,
                    drawings, specifications and data supplied by the Buyer to
                    the Seller (<b>"Buyer Materials"</b>) in safe custody at its
                    own risk, maintain the Buyer Materials in good condition
                    until returned to the Buyer, and not dispose or use the
                    Buyer Materials other than in accordance with the Buyer's
                    written instructions or authorisation; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;not do or omit to do anything which may cause
                    the Buyer to lose any licence, authority, consent or
                    permission on which it relies for the purposes of conducting
                    its business, and the Seller acknowledges that the Buyer may
                    rely or act on the Services.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                3.4 &nbsp;&nbsp;<b>Use of artificial intelligence</b>
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;In this clause, <b>"AI Tools"</b> means any
                    artificial intelligence, machine learning or generative
                    software or service used to create, generate, modify or
                    otherwise contribute to any Output or other content
                    delivered under the Contract, whether in whole or in part.
                    AI Tools does not include general-purpose productivity
                    features (such as spelling, grammar or transcription
                    assistance) that do not generate substantive content.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;The Seller shall not use AI Tools in the
                    performance of the Services or the creation of any Output
                    unless:
                  </p>
                  <ol type="i">
                    <li>
                      <p className="lato-regular">
                        {' '}
                        &nbsp;&nbsp;the Seller has first disclosed to the Buyer
                        in writing via the Twine Platform the intended use of AI
                        Tools, including a description of how and to what extent
                        AI Tools will be used; and
                      </p>
                    </li>
                    <li>
                      <p className="lato-regular">
                        {' '}
                        &nbsp;&nbsp;the Buyer has agreed to such use in writing
                        via the Twine Platform.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Responsibility for making the disclosure and
                    obtaining the Buyer's agreement under this clause 3.4 rests
                    solely with the Seller. The absence of any reference to AI
                    Tools in the Order, the Specification or the Buyer's brief
                    shall not be construed as consent to their use.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Where the Buyer has agreed to the use of AI
                    Tools, the Seller remains fully responsible for the Services
                    and the Output, including compliance with clause 3.3, and
                    warrants that the use of AI Tools shall not prevent the
                    Intellectual Property Rights in the Output vesting in the
                    Buyer in accordance with clause 7, and that the Output shall
                    not infringe the rights of any third party (and clause 8
                    (Indemnity) shall apply).
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Any use of AI Tools without the disclosure and
                    agreement required by this clause 3.4, or any representation
                    that Output created wholly or partly using AI Tools is
                    solely human-created work, constitutes a material breach of
                    the Contract which is irremediable for the purposes of
                    clause 9.2(a).
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Buyer remedies</h3>
              <p className="lato-regular">
                4.1 &nbsp;&nbsp;If the Seller fails to perform the Services by
                the applicable dates, the Buyer shall, without limiting or
                affecting other rights or remedies available to it, have one or
                more of the following rights:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to terminate the Contract with immediate effect
                    by giving written notice to the Seller;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to refuse to accept any subsequent performance
                    of the Services which the Seller attempts to make;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to recover from the Seller any costs incurred by
                    the Buyer in obtaining substitute services from a third
                    party;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to require a refund from the Seller of sums paid
                    in advance for Services that the Seller has not provided;
                    and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to claim damages for any additional costs, loss
                    or expenses incurred by the Buyer which are in any way
                    attributable to the Seller's failure to meet such dates.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                4.2 &nbsp;&nbsp;If the Seller has supplied Services that do not
                comply with the requirements of clause 3.3(d) then, without
                limiting or affecting other rights or remedies available to it,
                the Buyer shall have one or more of the following rights:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to terminate the Contract with immediate effect
                    by giving written notice to the Seller;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;(where relevant) to return the Output to the
                    Seller at the Seller's own risk and expense;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to require the Seller to provide repeat
                    performance of the Services, or to provide a full refund of
                    the price paid for the Services (if paid);
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to refuse to accept any subsequent performance
                    of the Services which the Seller attempts to make; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;to claim damages for any additional costs, loss
                    or expenses incurred by the Buyer arising from the Seller's
                    failure to comply with clause 3.3(d).
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                4.3 &nbsp;&nbsp;These Conditions shall extend to any substituted
                or remedial services provided by the Seller.
              </p>
              <p className="lato-regular">
                4.4 &nbsp;&nbsp;The Buyer's rights and remedies under the
                Contract are in addition to, and not exclusive of, any rights
                and remedies implied by statute and common law.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Buyer's obligations</h3>
              <p className="lato-regular">5.1 &nbsp;&nbsp;The Buyer shall:</p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;(where relevant) provide the Seller with
                    reasonable access at reasonable times to the Buyer's
                    premises for the purpose of providing the Services; and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;provide such necessary information for the
                    provision of the Services as the Seller may reasonably
                    request.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Charges and payment</h3>
              <p className="lato-regular">
                6.1 &nbsp;&nbsp;The Charges for the Services shall be set out in
                the Order, and shall be the full and exclusive remuneration of
                the Seller in respect of the performance of the Services. Unless
                otherwise agreed in writing by the Buyer, the Charges shall
                include every cost and expense of the Seller directly or
                indirectly incurred in connection with the performance of the
                Services.
              </p>
              <p className="lato-regular">
                6.2 &nbsp;&nbsp;
                <b>
                  Where Charges are to be paid through the Twine Platform.
                </b>{' '}
                The Seller shall invoice the Buyer on completion of the Services
                through the Twine Platform. The Charges shall be paid by the
                Buyer through the Twine Platform together with any fees payable
                to Twine for their services and provision of the Twine Platform,
                and payment shall be made to the Seller via the Twine Platform.
              </p>
              <p className="lato-regular">
                6.3 &nbsp;&nbsp;
                <b>
                  Where Charges are not to be paid through the Twine Platform.
                </b>{' '}
                The Seller shall invoice the Buyer on completion of the
                Services. Each invoice shall include such supporting information
                required by the Buyer to verify the accuracy of the invoice,
                including the relevant purchase order number. The Buyer shall
                pay Twine for any fees payable to Twine for their services and
                provision of the Twine Platform via the Twine Platform.
              </p>
              <p className="lato-regular">
                6.4 &nbsp;&nbsp;In consideration of the supply of the Services
                by the Seller, the Buyer shall pay the invoiced amounts within
                30 days of the date of a correctly rendered.
              </p>
              <p className="lato-regular">
                6.5 &nbsp;&nbsp;All amounts payable by the Buyer under the
                Contract are inclusive of amounts in respect of value added tax
                chargeable for the time being (<b>"VAT"</b>). If there is any
                additional VAT to be paid under the Contract by the Buyer to the
                Seller, the Buyer shall, on receipt of a valid VAT invoice from
                the Seller, pay to the Seller such additional amounts in respect
                of VAT as are chargeable on the supply of the Services at the
                same time as payment is due for the supply of the Services.
              </p>
              <p className="lato-regular">
                6.6 &nbsp;&nbsp;If the Buyer fails to make a payment due to the
                Seller under the Contract by the due date, then the Buyer shall
                pay interest on the overdue sum from the due date until payment
                of the overdue sum, whether before or after judgment. Interest
                under this clause 6.5 will accrue each day at 4% a year above
                the Bank of England's base rate from time to time, but at 4% a
                year for any period when that base rate is below 0%.
              </p>
              <p className="lato-regular">
                6.7 &nbsp;&nbsp;The Seller shall maintain complete and accurate
                records of the time spent and materials used by the Seller in
                providing the Services, and shall allow the Buyer to inspect
                such records at all reasonable times on request.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">
                Intellectual property rights
              </h3>
              <p className="lato-regular">
                7.1 &nbsp;&nbsp;All Intellectual Property Rights in or arising
                out of or in connection with the Services (other than
                Intellectual Property Rights in any Buyer Materials) shall be
                owned by the Buyer.
              </p>
              <p className="lato-regular">
                7.2 &nbsp;&nbsp;The Buyer grants the Seller a fully paid-up,
                non-exclusive, royalty-free non-transferable licence to copy and
                modify any materials provided by the Buyer to the Seller for the
                term of the Contract for the purpose of providing the Services
                to the Buyer.
              </p>
              <p className="lato-regular">
                7.3 &nbsp;&nbsp;All Buyer Materials are the exclusive property
                of the Buyer.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Indemnity</h3>
              <p className="lato-regular">
                8.1 &nbsp;&nbsp;The Seller shall indemnify the Buyer against all
                liabilities, costs, expenses, damages and losses (including but
                not limited to any direct, indirect or consequential losses,
                loss of profit, loss of reputation and all interest, penalties
                and legal costs (calculated on a full indemnity basis) and all
                other reasonable professional costs and expenses) suffered or
                incurred by the Buyer arising out of or in connection with:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;any claim brought against the Buyer for actual
                    or alleged infringement of a third party's intellectual
                    property rights arising out of, or in connection with, the
                    receipt, use or supply of the Services (excluding the Buyer
                    Materials); and
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;any claim made against the Buyer by a third
                    party arising out of, or in connection with, the supply of
                    the Services.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                8.2 &nbsp;&nbsp;This clause 8 shall survive termination of the
                Contract.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">Termination</h3>
              <p className="lato-regular">
                9.1 &nbsp;&nbsp;Without limiting or affecting any other right or
                remedy available to it, the Buyer may terminate the Contract:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;with immediate effect by giving written notice
                    to the Seller if:
                  </p>
                  <ol type="i">
                    <li>
                      <p className="lato-regular">
                        {' '}
                        &nbsp;&nbsp;the Seller's financial position deteriorates
                        to such an extent that in the Buyer's opinion the
                        Seller's capability to adequately fulfil its obligations
                        under the Contract has been placed in jeopardy; or
                      </p>
                    </li>
                    <li>
                      <p className="lato-regular">
                        {' '}
                        &nbsp;&nbsp;the Seller commits a breach of clause
                        3.3(h),
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;for convenience by giving the Seller two weeks'
                    written notice either on the Twine Platform or by e-mail.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                9.2 &nbsp;&nbsp;Without limiting or affecting any other right or
                remedy available to it, either party may terminate the Contract
                with immediate effect by giving written notice to the other
                party if:
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;the other party commits a material breach of any
                    term of the Contract which breach is irremediable or (if
                    such breach is remediable) fails to remedy that breach
                    within a period of three days after being notified to do so;
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;the other party takes any step or action in
                    connection with its entering administration, provisional
                    liquidation or any composition or arrangement with its
                    creditors (other than in relation to a solvent
                    restructuring), being wound up (whether voluntarily or by
                    order of the court, unless for the purpose of a solvent
                    restructuring), having a receiver appointed to any of its
                    assets or ceasing to carry on business or, if the step or
                    action is taken in another jurisdiction, in connection with
                    any analogous procedure in the relevant jurisdiction; or
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;the other party suspends, or threatens to
                    suspend, or ceases or threatens to cease to carry on all or
                    a substantial part of its business.
                  </p>
                </li>
              </ol>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">
                Consequences of termination
              </h3>
              <p className="lato-regular">
                10.1 &nbsp;&nbsp;On termination of the Contract for any reason,
                the Seller shall immediately deliver to the Buyer all Output
                whether or not then complete, and return all Buyer Materials. If
                the Seller fails to do so, then the Buyer may enter the Seller's
                premises and take possession of them. Until they have been
                returned or delivered, the Seller shall be solely responsible
                for their safe keeping and will not use them for any purpose not
                connected with the Contract.
              </p>
              <p className="lato-regular">
                10.2 &nbsp;&nbsp;Termination or expiry of the Contract shall not
                affect any of the rights, remedies, obligations or liabilities
                of the parties that have accrued up to the date of termination
                or expiry, including the right to claim damages in respect of
                any breach of the Contract which existed at or before the date
                of termination or expiry.{' '}
              </p>
              <p className="lato-regular">
                10.1 &nbsp;&nbsp;Any provision of the Contract that expressly or
                by implication is intended to come into or continue in force on
                or after termination or expiry of the Contract shall remain in
                full force and effect.
              </p>
            </li>

            <li>
              <h3 className="lato-bold mt mb pl">General</h3>
              <p className="lato-regular">
                11.1 &nbsp;&nbsp;<b>Force majeure.</b> Neither party shall be in
                breach of the Contract nor liable for delay in performing, or
                failure to perform, any of its obligations under the Contract if
                such delay or failure result from events, circumstances or
                causes beyond its reasonable control. If the period of delay or
                non-performance continues for two weeks, the party not affected
                may terminate the Contract by giving three days' written notice
                to the affected party.
              </p>
              <p className="lato-regular">
                11.2 &nbsp;&nbsp;<strong>Assignment and other dealings.</strong>
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;The Buyer may at any time assign, mortgage,
                    charge, subcontract, delegate, declare a trust over or deal
                    in any other manner with any or all of its rights and
                    obligations under the Contract.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;The Seller shall not assign, transfer, mortgage,
                    charge, subcontract, delegate, declare a trust over or deal
                    in any other manner with any of its rights and obligations
                    under the Contract without the prior written consent of the
                    Buyer.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                11.3 &nbsp;&nbsp;<strong>Confidentiality.</strong>
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Each party undertakes that it shall not at any
                    time disclose to any person any confidential information
                    concerning the business, affairs, customers, clients or
                    suppliers of the other party, except as permitted by clause
                    11.3(b).
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Each party may disclose the other party's
                    confidential information:
                  </p>
                  <ol type="i">
                    <li>
                      <p className="lato-regular">
                        {' '}
                        &nbsp;&nbsp;to its employees, officers, representatives,
                        subcontractors or advisers who need to know such
                        information for the purposes of carrying out the party's
                        obligations under the Contract. Each party shall ensure
                        that its employees, officers, representatives,
                        subcontractors or advisers to whom it discloses the
                        other party's confidential information comply with this
                        clause 11.3; and
                      </p>
                    </li>
                    <li>
                      <p className="lato-regular">
                        {' '}
                        &nbsp;&nbsp;as may be required by law, a court of
                        competent jurisdiction or any governmental or regulatory
                        authority.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Neither party shall use the other party's
                    confidential information for any purpose other than to
                    perform its obligations under the Contract.
                  </p>
                </li>
              </ol>

              <p className="lato-regular">
                11.4 &nbsp;&nbsp;<b>Entire agreement.</b> The Contract
                constitutes the entire agreement between the parties and
                supersedes and extinguishes all previous agreements, promises,
                assurances, warranties, representations and understandings
                between them, whether written or oral, relating to its subject
                matter.
              </p>
              <p className="lato-regular">
                11.5 &nbsp;&nbsp;<strong>Variation.</strong> Except as set out
                in these Conditions, no variation of the Contract, including the
                introduction of any additional terms and conditions, shall be
                effective unless it is agreed in writing and signed by the
                parties or their authorised representatives.
              </p>
              <p className="lato-regular">
                11.6 &nbsp;&nbsp;<strong>Waiver.</strong> A waiver of any right
                or remedy under the Contract or by law is only effective if
                given in writing and shall not be deemed a waiver of any
                subsequent right or remedy. A failure or delay by a party to
                exercise any right or remedy provided under the Contract or by
                law shall not constitute a waiver of that or any other right or
                remedy, nor shall it prevent or restrict any further exercise of
                that or any other right or remedy. No single or partial exercise
                of any right or remedy provided under the Contract or by law
                shall prevent or restrict the further exercise of that or any
                other right or remedy.
              </p>
              <p className="lato-regular">
                11.7 &nbsp;&nbsp;<strong>Severance.</strong> If any provision or
                part-provision of the Contract is or becomes invalid, illegal or
                unenforceable, it shall be deemed modified to the minimum extent
                necessary to make it valid, legal and enforceable. If such
                modification is not possible, the relevant provision or
                part-provision shall be deemed deleted. Any modification to or
                deletion of a provision or part-provision under this clause 11.7
                shall not affect the validity and enforceability of the rest of
                the Contract.
              </p>
              <p className="lato-regular">
                11.8 &nbsp;&nbsp;<strong>Notices.</strong>
              </p>
              <ol type="a">
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;Any notice or other communication given to a
                    party under or in connection with the Contract shall be in
                    writing and shall be delivered by hand or by pre-paid
                    first-class post or other next working day delivery service
                    at its registered office (if a company) or its principal
                    place of business (in any other case); or sent by email to
                    the address specified in the Order.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;A notice or other communication shall be deemed
                    to have been received: if delivered by hand, on signature of
                    a delivery receipt or at the time the notice is left at the
                    proper address; if sent by pre-paid first-class post or
                    other next working day delivery service, at 9.00 am on the
                    second Business Day after posting; if sent by email, at the
                    time of transmission, or, if this time falls outside
                    business hours in the place of receipt, when business hours
                    resume. In this clause 11.8(b), business hours means 9.00am
                    GMT to 5.00pm GMT Monday to Friday on a day that is not a
                    public holiday in the place of receipt.
                  </p>
                </li>
                <li>
                  <p className="lato-regular">
                    {' '}
                    &nbsp;&nbsp;This clause 11.8 does not apply to the service
                    of any proceedings or other documents in any legal action
                    or, where applicable, any other method of dispute
                    resolution.
                  </p>
                </li>
              </ol>
              <p className="lato-regular">
                11.9 &nbsp;&nbsp;<strong>Third party rights.</strong> Unless it
                expressly states otherwise, the Contract does not give rise to
                any rights under the Contracts (Rights of Third Parties) Act
                1999 to enforce any term of the Contract.
              </p>
              <p className="lato-regular">
                11.10 &nbsp;&nbsp;<strong>Governing law.</strong> The Contract,
                and any dispute or claim (including non-contractual disputes or
                claims) arising out of or in connection with it or its subject
                matter or formation shall be governed by, and construed in
                accordance with the law of England and Wales.
              </p>
              <p className="lato-regular">
                11.11 &nbsp;&nbsp;<strong>Jurisdiction.</strong> Each party
                irrevocably agrees that the courts of England and Wales shall
                have non-exclusive jurisdiction to settle any dispute or claim
                (including non-contractual disputes or claims) arising out of or
                in connection with the Contract or its subject matter or
                formation.
              </p>
            </li>
          </ol>

          <hr />

          <p className="lato-regular">
            For further terms of using Twine, please read our{' '}
            <a href="/terms">Terms and Conditions</a>.
          </p>
        </div>
      </div>
    );
  }
}
